var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.authenticated)?_c('v-content',{attrs:{"id":"dashboard-view"}},[_c('Toolbar'),_c('v-container',{staticClass:"pa-2"},[_c('Title',{attrs:{"text":_vm.translations.dashboard.active_courses.title}}),_c('v-divider',{staticClass:"mb-2"}),_c('UnifiedCourses')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }